

import React , {useEffect} from 'react';
import {Routes , Route} from 'react-router-dom'
import  './App.css'


import News from './components/pages/index.jsx';
import Home from './components/pages/home/home.jsx';
import CategoryNews from './components/pages/category/categoryPage.jsx';
import NewsContent from './components/pages/content/contentPage.jsx';
import RssFeedsMain from './components/pages/rssFeeds.jsx';
import PageNotFound from './components/pages/pageNotFound.jsx';
import AdSenseLoader from './components/common/AdSenseLoader.jsx';


const App = ({data}) =>{


       let isMobile = data?.[1]?.isMobile || false
           
   


              useEffect(() => {
  if (isMobile) return

  const handleContextMenu = (e) => e.preventDefault()
  const handleCopy = (e) => e.preventDefault()
  const handleCut = (e) => e.preventDefault()
  const handlePaste = (e) => e.preventDefault()

  const handleKeyDown = (e) => {
    if (
      (e.ctrlKey || e.metaKey) &&
      ['c', 'v', 'x', 's', 'u'].includes(e.key.toLowerCase())
    ) {
      e.preventDefault()
    }
  }

  document.addEventListener('contextmenu', handleContextMenu)
  document.addEventListener('copy', handleCopy)
  document.addEventListener('cut', handleCut)
  document.addEventListener('paste', handlePaste)
  document.addEventListener('keydown', handleKeyDown)

  // Disable image drag ONLY on desktop
  document.querySelectorAll('img').forEach((img) => {
    img.setAttribute('draggable', 'false')
  })

  return () => {
    document.removeEventListener('contextmenu', handleContextMenu)
    document.removeEventListener('copy', handleCopy)
    document.removeEventListener('cut', handleCut)
    document.removeEventListener('paste', handlePaste)
    document.removeEventListener('keydown', handleKeyDown)
  }
}, [isMobile])
  
  
            
       
   
    return(
     
      <main className="App d-flex flex-column align-items-center">
         {/* Load AdSense library once */}
          <AdSenseLoader />
        <Routes>
            <Route path="/" element={<News isMobile={isMobile}  />}>
            <Route index element={<Home data={data}  />} />
             <Route path="contents/:type" element={<CategoryNews data={data} />} />
            <Route path="content/:contentText" element={<NewsContent data={data}  />} />
            <Route path="rssDetails.rss" element={<RssFeedsMain />} /> 
            </Route>
            <Route path="*" element={<PageNotFound />} />
           </Routes>

     </main>
    )
}


export default App;
